module.exports = __webpack_public_path__ + "img/car_black.00ab2734.png";